/** basic.modelNum */
export default {
    model_notificationPla: "Тип уведомления",
    model_templateName: "Название шаблона",
    model_templateNamePla: "Введите название шаблона",
    model_deleteTips: "Удалить этот шаблон уведомления?",
    model_relevanceModel: "Связанная модель",
    model_drawerTitle: "Модели, связанные с шаблоном",
    model_dialogTitleOne: "Детали шаблона уведомления",
    model_dialogTItleAdd: "Новый шаблон уведомления",
    model_templatArgument: "Параметры шаблона",
    model_save: "Сохранить",
    model_NewCreater: "Создать сейчас",
    model_SelectNotification: "Выберите тип уведомления",
    model_selectEvent: "Выберите тип события",
    model_ruleTemplatArgument: "Заполните параметры шаблона",

    model_phone: "Звонок",
    model_note: "SMS",
    model_PCPush: "Push на ПК",
    model_AppPush: "Push в APP",
    model_OfficialAccounts: "Push офиц. аккаунта",

    message_saveTemplat: "Сначала сохраните параметры шаблона",
    message_createrSucc: "Создано!",
    message_createrLose: "Не удалось создать!",

    relevance_title: "Список моделей устройств",
    relevance_modelName: "Название модели",
    relevance_modelNumIntro: "Описание модели",
    relevance_addTips: "Добавить эту модель в шаблон уведомления?",
    relevance_cardTitle: "Модели, связанные с шаблоном уведомления",
    relevance_rmoeverTips: "Удалить эту модель из шаблона уведомления?",
}

